import { defineMessages } from 'react-intl';

export default defineMessages({
    externalLinkRequestFormIconLabel: {
        id: 'cv.external-links.link.external-link-request-form-icon-label',
        defaultMessage: 'Request form',
        description: 'Label for Request form external link icon',
    },
    externalLinkKnowledgeIconLabel: {
        id: 'cv.external-links.link.external-link-knowledge-icon-label',
        defaultMessage: 'Knowledge',
        description: 'Label for knowledge external link icon',
    },
    externalLinkHelpChannelIconLabel: {
        id: 'cv.external-links.link.external-link-help-channel-icon-label',
        defaultMessage: 'Help channel',
        description: 'Label for channel external link icon',
    },
    externalLinkHoverTooltip: {
        id: 'cv.external-links.link.external-link-hover-tooltip',
        defaultMessage: 'Opens in new tab',
        description: 'Label for external hover tooltip',
    },
});
